import PageHero from './page-hero';

export default PageHero;
